
import React, { Component } from 'react';
import styles from './shared.module.css';
import {Link } from 'react-router-dom';
import home from 'Assets/images/home.svg';
import thermometer from 'Assets/images/thermometer-half.svg';
import tools from 'Assets/images/tools.svg';
import clock from 'Assets/images/access_time.svg';
import classnames from 'classnames';


export default class NavigationBar extends Component {

    constructor(props){
        super(props);
        this.activatePage = this.activatePage.bind(this);
    }

    activatePage(event){  
        this.props.onGetActivePage(event.currentTarget.name);
     }

    render() {
        let showactivetab = this.props.OnGetActiveTab;
        return (
            <div className={styles.navigationBar}>

             <div className={styles.DesktopNavBar}>
                {
                (showactivetab[0])?
                <Link to="/FacilityManagement/home" className={classnames(styles.desktop_navigationBar_item,  {[styles.active_menu] : (window.location.hash ==="#/FacilityManagement/home")?true:false} )} 
                 replace name="Home" onClick={this.activatePage} >
                      <img src={home} alt="Trane Logo"  className={ (window.location.hash ==="#/FacilityManagement/home")?styles.desktop_black_home_icon:styles.desktop_home_icon}/> 
                 </Link> : ""
                }
                {
                (showactivetab[1])?
                    <Link to="/FacilityManagement/Comfort"  className={classnames(styles.desktop_navigationBar_item,  {[styles.active_menu] : (window.location.hash ==="#/FacilityManagement/Comfort")?true:false} )} 
                    replace  name="Comfort"  onClick={this.activatePage}> 
                    <span className={styles.desktop_navigationBar_text}> Comfort </span> 
                    </Link> : ""
                }
                {
                (showactivetab[2])?
                    <Link to="/FacilityManagement/AfterHours" className={classnames(styles.desktop_navigationBar_item,  {[styles.active_menu] :  window.location.hash.includes("AfterHours")?true:false} )} 
                    replace  name="After Hours"  onClick={this.activatePage}> 
                        <span className={styles.desktop_navigationBar_text}>  After-Hours </span>
                    </Link> : ""
                }
                {
                (showactivetab[3])?
                    <Link to="/FacilityManagement/Maintenance" 
                    className={classnames(styles.desktop_navigationBar_item,  {[styles.active_menu] :   window.location.hash.includes("Maintenance")?true:false} )} 
                    replace   name="Maintenance" onClick={this.activatePage} >
                        <span className={styles.desktop_navigationBar_text}> Maintenance </span>
                    </Link> : ""
                }
             </div>


            <div className={styles.mobileNavBar}>
                {
                (showactivetab[0]) ?
                <Link to="/FacilityManagement/home" 
                className={classnames(styles.mobile_navigationBar_item,  {[styles.mobile_active_menu] : (window.location.hash ==="#/FacilityManagement/home")?true:false} )} 
                replace name="Home" onClick={this.getdupActivePage}  >
                      <img src={home} alt="Trane Logo"  className={(window.location.hash ==="#/FacilityManagement/home")?styles.mobile_blk_home_icon:styles.home_icon}/> 
                 </Link> : ""
                }
                {
                (showactivetab[1]) ?
                    <Link to="/FacilityManagement/Comfort"
                    className={classnames(styles.mobile_navigationBar_item,  {[styles.mobile_active_menu] : (window.location.hash ==="#/FacilityManagement/Comfort")?true:false} )} 
                    replace  name="Comfort"  onClick={this.getdupActivePage} > 
                        <div className={styles.center} >
                        <img src={thermometer} alt="Trane Logo"  className={(window.location.hash ==="#/FacilityManagement/Comfort")?styles.blk_nav_icons:styles.nav_icons}/> <br  className={styles.nav_icons} />
                    <span className={styles.navigationBar_text}> Comfort </span> 
                        </div>
                    </Link>:""
                }
                {
                (showactivetab[2]) ?
                    <Link to="/FacilityManagement/AfterHours" 
                    className={classnames(styles.mobile_navigationBar_item,  {[styles.mobile_active_menu] :  window.location.hash.includes("AfterHours")?true:false} )} 
                    replace  name="After Hours"  onClick={this.getdupActivePage}> 
                        <div className={styles.center} >
                            <img src={clock} alt="Trane Logo"  className={(window.location.hash.includes("AfterHours"))?styles.blk_nav_icons:styles.nav_icons}/>  <br  className={styles.nav_icons} />
                        <span className={styles.navigationBar_text}>  After-Hours </span>
                        </div>
                    </Link> : ""
                }
                {
                (showactivetab[3]) ?
                    <Link to="/FacilityManagement/Maintenance" 
                    className={classnames(styles.mobile_navigationBar_item,  {[styles.mobile_active_menu] :  window.location.hash.includes("Maintenance")?true:false} )} 
                    replace   name="Maintenance" onClick={this.getdupActivePage} >
                        <div className={styles.center} >
                            <img src={tools} alt="Trane Logo"  className={(window.location.hash.includes("Maintenance"))?styles.blk_nav_icons:styles.nav_icons}
                            
                            />  <br  className={styles.nav_icons} />
                        <span className={styles.navigationBar_text}> Maintenance </span>
                        </div>
                    </Link> : ""
                }
             </div>

            </div>
        )
    }
}

